import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Role = {
  BackendUser: 'Administrador',
  ExecutiveUser: 'Ejecutivo',
  ClientUser: 'Cliente'
}

export default new Router({
  //mode:"history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard-executive",
          name: "statistics",
          meta: { authorize: [Role.ExecutiveUser, Role.BackendUser] },
          component: () => import("@/view/pages/Statistics.vue")
        },
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { authorize: [Role.ClientUser] },
          component: () => import("@/view/pages/Dashboard.vue")
        },
        {
          path: "/confirm/:codigo",
          name: "confirm-pay",
          meta: { authorize: [Role.ClientUser] },
          component: () => import("@/view/pages/Confirm.vue")
        },
        {
          path: "/comprobante",
          name: "comprobante",
          meta: { authorize: [Role.ClientUser] },
          component: () => import("@/view/pages/Comprobante.vue")
        },
        {
          path: "/comprobante/:codigo/view",
          name: "comprobante",
          meta: { authorize: [Role.ClientUser] },
          component: () => import("@/view/pages/Comprobante.vue")
        },
        {
          path: "/comprobante-error",
          name: "comprobante-error",
          meta: { authorize: [Role.ClientUser] },
          component: () => import("@/view/pages/ComprobanteError.vue")
        },
        {
          path: "/comprobante-error/:codigo/view",
          name: "comprobante-error",
          meta: { authorize: [Role.ClientUser] },
          component: () => import("@/view/pages/ComprobanteError.vue")
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile")
        },
        {
          path: "/payment",
          name: "payment",
          component: () => import("@/view/pages/payment/Payment"),
          children: [
            {
              path: "history",
              name: "history",
              component: () => import("@/view/pages/payment/History.vue")
            },
            {
              path: "history-payment",
              name: "history-payment",
              component: () => import("@/view/pages/payment/HistoryPayment.vue")
            },
            {
              path: "history-payment-error",
              name: "history-payment-error",
              component: () => import("@/view/pages/payment/HistoryPaymentError.vue")
            },
            {
              path: "history-payment-error-ebso",
              name: "history-payment-error-ebso",
              component: () => import("@/view/pages/payment/HistoryPaymentErrorEbso.vue")
            },
            {
              path: "credit",
              name: "credit",
              component: () => import("@/view/pages/payment/Credit.vue")
            },
            {
              path: "orders",
              name: "orders",
              component: () => import("@/view/pages/payment/Orders.vue")
            },
            {
              path: "confirm-order/:codigo",
              name: "confirm-order-pay",
              meta: { authorize: [Role.ClientUser] },
              component: () => import("@/view/pages/payment/ConfirmOrder.vue")
            },
            {
              path: "confirm-order-external/:codigo",
              name: "confirm-order-external-pay",
              meta: { authorize: [Role.ClientUser] },
              component: () => import("@/view/pages/payment/ConfirmExternalOrder.vue")
            },
          ]
        },
        {
          path: "/management/clients",
          name: "management",
          meta: { authorize: [Role.ExecutiveUser,Role.BackendUser] },
          component: () => import("@/view/pages/management/clients/List.vue"),
          /*children: [
              {
                path: ":token/edit",
                name: "edit-clientxx",
                component: () => import("@/view/pages/management/clients/Edit.vue")
              },
            ]*/
        },
        {
          path: "/management/clients/:token/edit",
          name: "edit-client",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/clients/Edit.vue")
        },
        {
          path: "/management/clients/create",
          name: "create-client",
          meta: { authorize: [Role.ExecutiveUser,Role.BackendUser] },
          component: () => import("@/view/pages/management/clients/Create.vue"),
        },
        {
          path: "/management/clients/client",
          name: "client-administrador",
          meta: { authorize: [Role.ExecutiveUser,Role.BackendUser] },
          component: () => import("@/view/pages/management/clients/Cliente.vue")
        },
        {
          path: "/management/config",
          name: "list-config",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/config/List.vue")
        },
        {
          path: "/management/users",
          name: "management",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/users/List.vue"),
        },
        {
          path: "/management/users/:token/edit",
          name: "edit-user",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/users/Edit.vue")
        },
        {
          path: "/management/users/create",
          name: "create-user",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/users/Create.vue"),
        },

        {
          path: "/management/companies",
          name: "management",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/companies/List.vue"),
        },
        {
          path: "/management/companies/:codigoEmpresa/edit",
          name: "edit-company",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/companies/Edit.vue")
        },
        {
          path: "/management/companies/create",
          name: "create-company",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/companies/Create.vue"),
        },


        {
          path: "/management/companies-client",
          name: "management-client",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/companiesClient/List.vue"),
        },
        {
          path: "/management/companies-client/:tokenEmpresa/edit",
          name: "edit-company-client",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/companiesClient/Edit.vue")
        },
        {
          path: "/management/companies-client/create",
          name: "create-company-client",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/companiesClient/Create.vue"),
        },

        {
          path: "/management/notifications",
          name: "notifications",
          meta: { authorize: [Role.ExecutiveUser,Role.BackendUser] },
          component: () => import("@/view/pages/management/notifications/List.vue"),
        },
        {
          path: "/management/notifications/create",
          name: "create-notifications",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/notifications/Configure.vue"),
        },
        {
          path: "/management/quadrature",
          name: "quadrature",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/Quadrature.vue")
        },
        {
          path: "/management/quadrature-query",
          name: "quadrature-query",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/QuadratureQuery.vue")
        },
        {
          path: "/management/quadrature-notfound",
          name: "quadrature-notfound",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/QuadratureNotFound.vue")
        },
        {
          path: "/management/quadrature-bam",
          name: "quadrature-bam",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/QuadratureBam.vue")
        },
        {
          path: "/management/quadrature-report",
          name: "quadrature-report",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/management/QuadratureReport.vue")
        },

        {
          path: "/management/envioDocumentos",
          name: "envioDocumentos",
          meta: { authorize: [Role.ExecutiveUser,Role.BackendUser] },
          component: () => import("@/view/pages/management/envioDocumento/EnvioDocumento.vue"),
        },

        {
          path: "/management/listaNegra",
          name: "lista-negra",
          meta: { authorize: [Role.ExecutiveUser,Role.BackendUser] },
          component: () => import("@/view/pages/management/listaNegra/List.vue"),
        },
      ]
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },
    {
      path: "/external",
      component: () => import("@/view/layout/LayoutExternal"),
      children: [
        {
          path: "external-payment/:token",
          name: "external-orders",
          component: () => import("@/view/pages/payment/ExternalOrders.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login")
        },
        
        {
          name: "changePassword",
          path: "/changePassword/:token/view",
          component: () => import("@/view/pages/auth/ChangePassword")
        },
        {
          name: "proveedor",
          path: "/proveedor",
          component: () => import("@/view/pages/auth/Proveedor")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Register")
        },
        {
          name: "registerConfirm",
          path: "/register-confirm",
          component: () => import("@/view/pages/auth/RegisterConfirm")
        },
        {
          name: "block",
          path: "/block",
          component: () => import("@/view/pages/auth/Block")
        },
        {
          name: "recovery",
          path: "/recovery",
          component: () => import("@/view/pages/auth/Recovery")
        },
        {
          name: "confirm",
          path: "/confirm/:token/view",
          component: () => import("@/view/pages/auth/RecoveryConfirm")
        },
      ]
    },
    {
      path: "/executive",
      name: "executive",
      component: () => import("@/view/pages/executive/Auth"),
      children: [
        {
          name: "login-executive",
          path: "/executive/login",
          component: () => import("@/view/pages/executive/Login")
        },
        {
          name: "block-executive",
          path: "/block-executive",
          component: () => import("@/view/pages/executive/Block")
        },
        {
          name: "changePassword-executive",
          path: "/executive/changePassword/:token/view",
          component: () => import("@/view/pages/executive/ChangePassword")
        },
        {
          name: "proveedor-executive",
          path: "/executive/proveedor",
          component: () => import("@/view/pages/executive/Proveedor")
        },
        {
          name: "register",
          path: "/executive/register",
          component: () => import("@/view/pages/executive/Register")
        },
        {
          name: "recovery-executive",
          path: "/executive/recovery",
          component: () => import("@/view/pages/executive/Recovery")
        },
        {
          name: "confirm-executive",
          path: "/executive/confirm/:token/view",
          component: () => import("@/view/pages/executive/RecoveryConfirm")
        },
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    },
   
    

  ]
});
